import { defineMessages } from 'react-intl';

export default defineMessages({
	title: {
		defaultMessage: 'Profile',
		description: 'headline of the customer portal profile page',
		id: 'cv.user.profile.title',
	},
});
